"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=algoliaConfig.js.map